function Error() {
    return (
      <div>
        <h1>Une erreur est survenue</h1>
      </div>
    );
  }
  
  export default Error;
  